"use strict";
/**
 * Created by rouven on 23.02.17.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var find_in_object_1 = __importDefault(require("@wikom/find-in-object"));
var BaseColumn_1 = __importDefault(require("./BaseColumn"));
var Column = function (_a) {
    var rowData = _a.rowData, idx = _a.idx, rest = __rest(_a, ["rowData", "idx"]);
    return react_1["default"].createElement(BaseColumn_1["default"], __assign({ rowData: rowData, idx: idx }, rest), (0, find_in_object_1["default"])(idx, rowData));
};
exports["default"] = Column;
